import Page from '../../page';
import WallManager from "./WallManager/index";
import PopinFilter, {MANAGE_POPIN_FILTER_EVENT} from "../popin-filter/popin-filter";
import States from "../../../helpers/states.js";
import ToggleFavorite from "../../../components/toggle-favorite/toggle-favorite";

export default class RecipesWallDesktop extends Page {
    constructor(...args) {
        super(...args);

        bindAll(this, [
            '_openPopinFilter',
            '_closePopinFilter'
        ]);

        this.dataWall = dataWall;
        this.dataRecipes = [...this.dataWall.recipes_landscape, ...this.dataWall.recipes_portrait];
        this.favoritesComponents = new Map();

        this._retrieveDOM();

        this._PopinFilter = new PopinFilter();
    }

    init() {
        this.wall = new WallManager({
            container: this.dom.views.wall,
            datas: this.dataWall
        });

        this.on('page:load', () => {
            this.wall.displayTutorial();
        });

        // set favorites toggle component and state on recipe items
        this.updateFavoriteComponents();

        // when wall grid is updated, set toggle component on new items
        this.wall.on('grid:update', () => {
            this.updateFavoriteComponents();
        })
    }

    /**
     * Update favorite item components
     */
    updateFavoriteComponents() {

        // get favorites dom elements
        const favoritesNodes = document.body.querySelectorAll('[data-component="toggleFavorite"]');

        // init toggleFavorite components for each elements if not already init
        for (let i = 0; i < favoritesNodes.length; i++) {
            const favoriteNode = favoritesNodes[i];
            // get node linked toggleFavorite component unique id
            const toggleFavoriteId = favoriteNode.toggleFavorite ? favoriteNode.toggleFavorite.uid : null;

            // if id not already stored init component ToggleFavorite for node
            if(!this.favoritesComponents.has(toggleFavoriteId)) {
                const toggleFavorite = new ToggleFavorite(favoriteNode);
                toggleFavorite.init();
                toggleFavorite.bind();
                toggleFavorite.on('update', () => {
                    this._updateFavoriteItemState(toggleFavorite);
                });
                this.favoritesComponents.set(toggleFavorite.uid, toggleFavorite);
            }
        };

        // remove favorite components not in dom
        for (let id of this.favoritesComponents.keys()) {
            const foundRecipe = Array.from(favoritesNodes).find(favoriteNode => {
                const toggleFavoriteId = favoriteNode.toggleFavorite ? favoriteNode.toggleFavorite.uid : null;
                return toggleFavoriteId === id
            });
            if(!foundRecipe) {
                this.favoritesComponents.delete(id);
            }
        };
    }

    /**
     * Update state of a single favorite item
     * @param {ToggleFavorite} toggleFavorite - Favorite item component
     */
    _updateFavoriteItemState(toggleFavorite) {
        const recipe = this.dataRecipes.find(recipe => recipe.recipe_id === toggleFavorite._recipe_id);
        // update recipe data
        recipe.is_favorite = toggleFavorite.active;

        //toggleFavorite.classList[toggleFavoriteComp.active ? 'add' : 'remove']('active');
        // update favorite style on same recipes duplicated
        const favItems = document.body.querySelectorAll(`[data-recipe-id="${toggleFavorite._recipe_id}"]`);
        for (let i = 0; i < favItems.length; i++) {
                favItems[i].classList[toggleFavorite.active ? 'add' : 'remove']('active');
        }
    }

    _retrieveDOM() {
        this.dom.views = {};

        this.dom.views.wall = this._find('.js-wall');
    }

    bind() {
        this._PopinFilter.on( MANAGE_POPIN_FILTER_EVENT.OPEN, this._openPopinFilter );
        this._PopinFilter.on( MANAGE_POPIN_FILTER_EVENT.CLOSE, this._closePopinFilter );
    }


    _openPopinFilter() {
        if( this.Components.hasOwnProperty( 'Menu' ) ) {
            this.Components['Menu'].hideMenu();
        }
    }

    _closePopinFilter() {
        if( this.Components.hasOwnProperty( 'Menu' ) ) {
            this.Components['Menu'].showMenu();
        }
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}


// WEBPACK FOOTER //
// ./src/js/pages/recipes/wall/recipes-wall.desktop.js